import { Alert, AlertDescription, Badge } from "@beweegbaas/ui";
import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { Page } from "#/components/page";
import { ImportFileDropUpload } from "#/modules/school.import/components/import-file-drop-upload";
import { ImportStepsOverview } from "#/modules/school.import/components/import-steps-overview";
import { ImportVerwerkersovereenkomstRequired } from "#/modules/school.import/components/import-verwerkersovereenkomst-required";
import { getImportIndexData } from "#/modules/school.import/import.functions";
import { m } from "#/paraglide/messages";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/detail/import/$type/",
)({
  loader: ({ params }) =>
    getImportIndexData({
      data: { school: params.school, type: params.type, locale: params.locale },
    }),
  component: StartImport,
});

const importLayoutRoute = getRouteApi(
  "/$locale/{-$schoolyear}/_authenticated/$school/detail/import/$type",
);

function StartImport() {
  const { currentSchooljaar, isAllowedToImport, licentieType } = importLayoutRoute.useLoaderData();
  const schoolYear = `${currentSchooljaar.fromYear}-${currentSchooljaar.toYear}`;
  return (
    <>
      <Page.MobileHeader />
      <Page.Body>
        <Page.FocusedLayout align="start">
          <div className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              {/* The mobile header bar already shows this title (nav-label fallback). */}
              <Page.Title className="max-md:hidden">Importeren</Page.Title>
              <Badge>{schoolYear}</Badge>
            </div>
            {isAllowedToImport && (
              <p className="text-muted-foreground text-sm">
                Upload het bestand met de leerlingen die je wilt importeren of wijzigen.
              </p>
            )}
          </div>
          {isAllowedToImport ? (
            <>
              <ImportStepsOverview />
              <div className="flex flex-col gap-3">
                <Alert variant="destructive">
                  <IconTablerAlertTriangle className="size-4" />
                  <AlertDescription>{m["import.student_number_notice"]()}</AlertDescription>
                </Alert>
                <ImportFileDropUpload showDownloadTemplate={false} />
              </div>
            </>
          ) : (
            <ImportVerwerkersovereenkomstRequired isTrial={licentieType === "Proefperiode"} />
          )}
        </Page.FocusedLayout>
      </Page.Body>
    </>
  );
}
